import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Steps, Button, Input, PageHeader } from "antd";
import { useState, useContext } from "react";
import { ReviewContext } from "../../lib/review-context";
import { Intro } from "../intro";

const STEPS = [
  {
    question: "What's your name?",
    placeholder: "John Doe",
    id: "name",
  },
  {
    question: "Who is your favorite coworker? (full name)",
    placeholder: "David Dunkovich",
    id: "coworker",
  },
  {
    question: `What's your favorite animal? (singular)`,
    placeholder: `dog`,
    isLowerCase: true,
    id: "animal",
  },
  {
    question: "Think of any adjective",
    placeholder: "happy",
    isLowerCase: true,
    id: "adjective1",
  },
  {
    question: "One more adjective",
    placeholder: "funny",
    isLowerCase: true,
    id: "adjective2",
  },
  {
    question: "Think of a object (singular)",
    placeholder: "spoon",
    isLowerCase: true,
    id: "noun1",
  },
  {
    question: `Name any body part (singular)`,
    isLowerCase: true,
    placeholder: "leg",
    id: "bodypart",
  },
];

const DEFAULT_INPUTS = STEPS.reduce((acc, curr) => {
  return { ...acc, [curr.id]: "" };
}, {});

export const Survey = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [inputs, setInputs] = useState(DEFAULT_INPUTS);
  const { addReview, loading, debugQuestions } = useContext(ReviewContext);

  const onSubmit = async () => {
    await addReview(inputs);
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <PageHeader
        title={<div style={{ paddingRight: 5 }}>Welcome</div>}
        style={{
          padding: 0,
          marginBottom: 12,
        }}
      />
      <ul style={{ marginBottom: 24 }}>
        <li>I know you love surveys so I built a survey 💘</li>
        <li>
          Your answers will be used publicly in some way so don't get me fired
          🙏
        </li>
        <li>
          You can only submit your answers once. Take your time and be creative
          🦄
        </li>
      </ul>
      <Steps direction="vertical" current={currentStep}>
        {STEPS.map((step, i) => {
          return (
            <CustomStep
              key={step.id}
              title={step.question}
              description={
                <Input
                  value={inputs[step.id]}
                  placeholder={step.placeholder}
                  onChange={({ target: { value } }) => {
                    setInputs((prev) => ({
                      ...prev,
                      [step.id]: step.isLowerCase
                        ? value.toLowerCase().slice(0, 70)
                        : value.slice(0, 70),
                    }));

                    setCurrentStep((currentStep) => Math.max(i, currentStep));
                  }}
                />
              }
            />
          );
        })}
      </Steps>
      <Button
        type="primary"
        block
        onClick={onSubmit}
        disabled={
          !debugQuestions && !Object.keys(inputs).every((id) => inputs[id])
        }
        loading={loading}
      >
        Submit
      </Button>
      <Button
        type="secondary"
        block
        onClick={() => navigate("../results")}
        style={{ marginTop: 8 }}
      >
        Skip
      </Button>
      <Intro />
    </div>
  );
};

const CustomStep = styled(Steps.Step)`
  height: 100px;
  display: flex;
`;
